/**
 * Shared scoping for the B2C reschedule/cancel mutations (PLA-878).
 *
 * A mutation captures the picker session id plus the order and token it was
 * started for. When it settles it may touch UI state only if all three still
 * match, so a slow request can neither close nor mark up a picker that was
 * reopened, or opened for a different tracking order, in the meantime.
 */

export interface B2cScopeStore {
  rescheduleRequestId: number
  currentOrderId?: string
  trackingToken?: string
}

export interface B2cMutationScope {
  id: number
  orderId?: string
  token?: string
}

/** Call inside an MST action: claims a new session id and snapshots the target. */
export function startB2cMutation(self: B2cScopeStore): B2cMutationScope {
  self.rescheduleRequestId += 1
  return { id: self.rescheduleRequestId, orderId: self.currentOrderId, token: self.trackingToken }
}

export function isCurrentB2cMutation(self: B2cScopeStore, scope: B2cMutationScope): boolean {
  return (
    scope.id === self.rescheduleRequestId &&
    scope.orderId === self.currentOrderId &&
    scope.token === self.trackingToken
  )
}
